import { IFetchConfig } from "@elsa-zku/lib/helpers/fetch";
import fetch from "./http-client";

import { Group, UpdateGroupDto, CreateGroupDto } from "./data-contracts";

export const groupControllerFindAll = (
  // query: {
  //   //buildingId: number;
  //   limit: number;
  //   offset: number;
  // },
  params?: IFetchConfig,
) => fetch<Group[]>("GET", `territory_group`, null, /* query, */ params);

export const groupControllerCreate = (data: CreateGroupDto, params?: IFetchConfig) =>
  fetch<Group>("POST", `territory_group`, data, params);

export const groupControllerUpdate = (id: number, data: UpdateGroupDto, params?: IFetchConfig) =>
  fetch<Group>("PUT", `territory_group/${id}`, data, params);

export const groupControllerRemove = (id: number, params?: IFetchConfig) =>
  fetch<void>("DELETE", `territory_group/${id}`, null, params);
